






























import { Component, Vue, Prop } from 'vue-property-decorator';

import { GroupUserAttributeOption } from '../../../../jbi-shared/types/myjbi-group.types';
import { GroupUserAttribute } from '../../../../store/modules/admin/types/group-user-attribute-template.types';

@Component({})
export default class ListAttributeOption extends Vue {
  @Prop() attribute!: GroupUserAttribute;

  /** Derived from props — do not snapshot in a class field (props are not set during data()). */
  get listConfig(): GroupUserAttributeOption | null {
    return this.attribute?.option ?? null;
  }
}
